// JC-EVO 09/25/2026: In The Box design C: arrow buttons for the photo rail of sections/whats-in-the-box.liquid.
// <witb-rail> wraps ul.witb__grid (the scroll-snap list) and .witb__paddles (two buttons, [hidden] in the markup).
// The buttons show only when the rail overflows, are disabled at either end, and scroll by the number of whole
// tiles in view. Loaded as a module from each section instance (the browser runs it once); safe to re-run.
if (!customElements.get('witb-rail')) {
  customElements.define('witb-rail', class extends HTMLElement {
    connectedCallback() {
      if (!this.paddles) {   // first connection: find the parts and bind the listeners once
        const list = this.querySelector('.witb__grid'), paddles = this.querySelector('.witb__paddles');
        if (!list || !paddles) return;
        this.list = list;
        this.paddles = paddles;
        [this.prev, this.next] = paddles.querySelectorAll('button');
        this.update = this.update.bind(this);
        this.prev.addEventListener('click', () => this.page(-1));
        this.next.addEventListener('click', () => this.page(1));
        list.addEventListener('scroll', this.update, { passive: true });
        this.ro = new ResizeObserver(this.update);   // also fires when the In The Box tab reveals the section
      }
      this.ro.observe(this.list);
      this.update();
    }
    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
    }
    page(dir) {
      const l = this.list, card = l.querySelector('.witb__card');
      const cs = getComputedStyle(l), gap = parseFloat(cs.columnGap) || 0, view = l.clientWidth - (parseFloat(cs.paddingRight) || 0);
      const step = card ? card.getBoundingClientRect().width + gap : view;
      const n = Math.max(1, Math.floor((view + gap) / step));
      const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      l.scrollBy({ left: dir * n * step, behavior: smooth ? 'smooth' : 'auto' });
    }
    update() {
      const l = this.list, max = l.scrollWidth - l.clientWidth, fits = max <= 2;
      this.paddles.hidden = fits;
      this.prev.disabled = fits || l.scrollLeft <= 2;
      this.next.disabled = fits || l.scrollLeft >= max - 2;
    }
  });
}
